import { Injectable } from '@angular/core'; 
import 'rxjs/add/observable/of';
import { StorageService } from '../providers/storage.service'; 
import { tokenNotExpired } from "angular2-jwt";
import { Router } from '@angular/router';

@Injectable()
export class AuthService {
    
    constructor(private router: Router, private storage: StorageService) { }

    loggedIn(): boolean {
        return tokenNotExpired();
    }

    logout(){
        this.storage.remove("encodepwd");
        this.storage.remove("sysconfig");
        this.storage.remove("User");
        this.storage.remove("token");
        this.storage.clear();
        this.router.navigate(["domains"]);
    }

    getToken(): string {
        return this.storage.readString("token");
    }

}


// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./node_modules/angular2-template-loader!./node_modules/tslint-loader??ref--7-0!./src/providers/auth.service.ts